import { render, staticRenderFns } from "./CommunityNews.vue?vue&type=template&id=4b53d3c2&"
import script from "./CommunityNews.vue?vue&type=script&lang=js&"
export * from "./CommunityNews.vue?vue&type=script&lang=js&"
import style0 from "./CommunityNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports